import React from "react";
import { TableCell } from "@mui/material";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

// Columna sin encabezado visible: botón de motivo de continuidad, solo visible
// cuando la solicitud está en Estado 1 (PRE-APROBADO) o 2 (APROBADO).
export default function CeldaMotivoContinuidad({ data, setIsOpenMotivo, setDataInforme }) {
  return (
    <TableCell align="center">
      {(data.Estado === 1 || data.Estado === 2) ? (
        <button
          onClick={() => {
            setIsOpenMotivo(true);
            setDataInforme(data);
          }}
          className="bg-pink-100 text-pink-800 hover:bg-pink-200 hover:text-pink-900 transition-all duration-200 rounded-full p-2"
        >
          <NoteAltIcon className="text-pink-800" />
        </button>
      ) : (
        ""
      )}
    </TableCell>
  );
}
